import { useEffect, useState} from "react";
import axios from "axios";
import { useDispatch } from "react-redux";
import { finishLoading2, startLoading2 } from "../Redux/actions/UIError";
const strapiBaseUrl = process.env.REACT_APP_API_STRAPI_URL;

const useStrapi = (endpoint) => {
    const [data, setData] = useState(null);
    const [error, setError] = useState(null);
    const dispatch = useDispatch()
    
    useEffect(() => {
        dispatch(startLoading2())
        axios.get(`${strapiBaseUrl}${endpoint}`)
        .then((strapiData) => {
            setData(strapiData.data)
            dispatch(finishLoading2())
        }).catch((error) => {
            setError("Error al cargar datos dinámicos")
            dispatch(finishLoading2())
        })
    }, []);

    return [data, error];
};

export default useStrapi;